<template>
  <div class="payment">
    <div class="content">
      <div class="title">收银台</div>
      <div class="content1">
        <div class="t">支付模块</div>
        <div class="t-content">代取快递-上门</div>
      </div>
      <div class="content2">
        <div class="t">商品信息</div>
        <div class="t-content">{{ placeData.pricingName }}</div>
      </div>
      <div class="content3">
        应付：<span class="price1">￥{{ placeData.total }}</span>
      </div>
      <div class="content4">
        <div class="t">平台优惠</div>
        <div class="price1">￥0.00</div>
      </div>
      <div class="content3">
        实际应付：<span class="price2">￥{{ payable }}</span>
      </div>
      <van-button
        :loading="loading"
        class="but"
        @click="handleSubmit"
        type="info"
        >微信支付</van-button
      >
    </div>
  </div>
</template>

<script>
import * as http from "@/api/index.js";
import wx from "weixin-js-sdk";
import { Toast } from "vant";
export default {
  name: "Payment",
  data() {
    return {
      placeData: {},
      loading: false,
    };
  },
  created() {
    this.init();
  },
  computed: {
    payable() {
      const { total } = this.placeData;
      if (!total) {
        return 0.0;
      }
      // 平台优惠
      const discount = 0;
      // 实际应付
      const payable = total - discount;
      return payable.toFixed(2);
    },
  },
  methods: {
    init() {
      document.title = "收银台";
      this.placeData = JSON.parse(this.$route.query.placeData);
    },
    async handleSubmit() {
      try {
        this.loading = true;
        const { appId } = JSON.parse(localStorage.getItem("tokenVo"));
        const { data: wxConfig } = await http.getWxConfig(appId);
        const { data } = await http.order(this.placeData);
        wx.config({
          debug: false,
          appId: appId,
          timestamp: wxConfig.timeStamp,
          nonceStr: wxConfig.nonceStr,
          signature: wxConfig.signature,
          jsApiList: ["chooseWXPay"],
        });
        wx.error((res) => {
          console.log("wx.error", res);
        });
        wx.ready(() => {
          // 发起支付请求
          wx.chooseWXPay({
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            package: data.pkg,
            signType: data.signType,
            paySign: data.sign,
            // paySign: paySign,
            success: (res) => {
              // 支付成功的回调
              if (res.errMsg == "chooseWXPay:ok") {
                Toast.success("支付成功");
                // 支付成功后跳转到订单列表页面
                this.$router.go(-1);
              }
            },
            cancel: (res) => {
              // 用户取消支付的回调
              console.log("用户取消支付", res);
            },
            fail: (res) => {
              // 支付失败的回调
              console.log("支付失败：" + res.err_msg);
            },
          });
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.payment {
  height: 100%;

  background: linear-gradient(to right, #a4c6eb, #3a8ac0);

  .content {
    padding: 8px;
    background-color: #fff;
  }

  .title {
    height: 40px;
    border-radius: 5px;
    background-color: #0c79b1;
    color: white;
    padding: 0 10px;
    line-height: 40px;
    font-size: 16px;
    margin-bottom: 25px;
  }

  .content1 {
    border: solid 1px #ccc;
    margin-bottom: 10px;
    border-radius: 5px;

    .t {
      padding: 10px;
      font-size: 16px;
      font-weight: 600;
      border-bottom: solid 1px #ccc;
    }

    .t-content {
      padding: 10px;
      font-size: 14px;
    }
  }

  .content2 {
    border: solid 1px #ccc;
    border-radius: 5px;

    .t {
      padding: 10px;
      font-size: 16px;
      font-weight: 600;
      border-bottom: solid 1px #ccc;
    }

    .t-content {
      padding: 10px;
      font-size: 14px;
    }
  }

  .content3 {
    height: 40px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .content4 {
    display: flex;
    padding: 10px;
    border-radius: 5px;
    justify-content: space-between;
    border: solid 1px #ccc;
  }

  .price1 {
    color: red;
    font-size: 16px;
  }

  .price2 {
    color: red;
    font-size: 18px;
    font-weight: 600;
  }

  .but {
    width: 100%;
    height: 40px;
    border-radius: 5px;
    margin-bottom: 20px;
    margin-top: 20px;
  }
}
</style>
